import React, { useEffect, useRef, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../_redux/user-group-authorization/UserGroupAuthorizationAction";
import { CustomSelect, noUserGroupAlert, redirectToPages, resultAlert } from "../../../../../_helpers/Helpers";
import { 
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  ModalProgressBar
} from "../../../../../_metronic/_partials/controls";
import { UserGroupAuthorizationEditForm } from "./UserGroupAuthorizationEditForm";

export function UserGroupAuthorizationPage() {
  const [userGroupId, setUserGroupId] = useState();

  // Getting curret state of UserGroupAuthorization from store (Redux)
  const dispatch = useDispatch();
  const { actionLoading, isSuccess, type, userGroups, modules, moduleAndAuthorities } = useSelector(
    (state) => ({
      actionLoading: state.userGroupAuthorization.actionLoading,
      isSuccess: state.userGroupAuthorization.isSuccess,
      type: state.userGroupAuthorization.type,
      userGroups: state.userGroupAuthorization.userGroups,
      modules: state.userGroupAuthorization.modules,
      moduleAndAuthorities: state.userGroupAuthorization.moduleAndAuthorities
    }),
    shallowEqual
  );
  
  useEffect(() => {
    dispatch(actions.getList());    
    return () => dispatch(actions.cleanAuthorities());
  }, [dispatch]);

  const saveAuthorities = (values) => {
    if (!userGroupId) {
      noUserGroupAlert();
      return;
    }
    dispatch(actions.saveAuthorities(userGroupId, values)).then((result) => onResult(result));
  }

  const onResult = ({ isSuccess, type, message }) => {
    resultAlert(type, message);
    if (isSuccess) dispatch(actions.getAuthorities(userGroupId));
  };
  
  const btnRef = useRef();  
  const saveAuthoritiesClick = () => {
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    }
  };  

  // Yetki ve Hata Kontrolleri
  if (isSuccess === false) return redirectToPages(type);

  return (
    <>
      <Card>
        { actionLoading && <ModalProgressBar /> }
        <CardHeader title="Kullanıcı Grubu Yetkilendirme" />
        <CardBody>
          <div className="row">
            <div className="col-3 mt-3">
              Kullanıcı Grubu <span>*</span>
            </div>
            <div className="col-4">
              <CustomSelect
                options={userGroups}
                onChange={option => dispatch(actions.getAuthorities(option.value)).then(() => setUserGroupId(option.value))}
              />
            </div>
          </div>
        </CardBody>
      </Card>
      <Card>
        <CardHeader title="Kullanıcı Grubu Yetkileri" />
        <CardBody>
          <UserGroupAuthorizationEditForm
            modules={modules}
            moduleAndAuthorities={moduleAndAuthorities}
            btnRef={btnRef}
            saveAuthorities={saveAuthorities}
          />
        </CardBody>
        <CardFooter>
          <div className="offset-sm-2">          
            <button
              type="submit"
              className="btn btn-primary"
              onClick={saveAuthoritiesClick}
            >
              Kaydet
            </button>          
          </div>
        </CardFooter>
      </Card>
    </>    
  );
}